import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { Router } from '@angular/router';
import { BreadcrumbService } from '../../../../shared/service/breadcrumb.service';
import { SharedDataService } from '../../../../shared/service/shared-data/shared-data.service';
import { OrganizationService } from '../../../../modules/settings/location/services/organization.service';
import { LocationService } from '../../../../modules/settings/location/services/location.service';
import { EnvironmentService } from '../../../../shared/environment.service';
import { EMPTY, Subject, switchMap, takeUntil } from 'rxjs';
import { PermissionsService } from 'src/app/services/permissions.service';
import { PERMISSIONS } from 'src/app/constants/permissions.constants';
import { UserLocationService } from 'src/app/shared/service/user-location.service';
import { PlanningDataService } from 'src/app/shared/service/planning-data.service';
import { MaskedQueryService } from 'src/app/shared/service/masked-query.service';

@Component({
  selector: 'app-config-dropdown',
  templateUrl: './config-dropdown.component.html',
  styleUrl: './config-dropdown.component.scss',
  animations: [
    trigger('rotateIcon', [
      state('down', style({ transform: 'rotate(0)' })),
      state('right', style({ transform: 'rotate(270deg)' })),
      transition('down <=> right', animate('200ms ease-out')),
    ]),
  ],
})
export class ConfigDropdownComponent implements OnInit {
  orgDetails: any;
  locDetails: any;
  menuStates: boolean[] = [];
  showDropDown: boolean = false;
  isActive: boolean = false;
  selectedMenu: any = [
    { label: 'Home', url: '/dashboard' },
    { label: 'Configuration', url: '/configuration' },
  ];
  selectedOption: any;
  showLocData: boolean = false;
  @ViewChildren(MatMenu)
  menuComponents!: QueryList<MatMenu>;
  subMenuItems = [
    {
      label: 'Location Details',
      routerLink: '/locations',
      location: 'location',
      requiredPermissions: [PERMISSIONS.LOCATION_DETAILS_READ, PERMISSIONS.LOCATION_DETAILS_WRITE]
    },
    { label: 'Shift/ Duties', routerLink: '/duties', location: 'duties', requiredPermissions: [PERMISSIONS.DUTY_MANAGEMENT_READ,PERMISSIONS.DUTY_MANAGEMENT_WRITE,PERMISSIONS.DUTY_PLANNING_ACTIVATION_READ,PERMISSIONS.DUTY_PLANNING_ACTIVATION_WRITE,PERMISSIONS.DUTY_DEPARTMENT_MAPPING_READ,PERMISSIONS.DUTY_DEPARTMENT_MAPPING_WRITE] },
    { label: 'Holidays', routerLink: '/holidays', location: 'holidays', requiredPermissions: [PERMISSIONS.HOLIDAY_DETAILS_READ, PERMISSIONS.HOLIDAY_DETAILS_WRITE,PERMISSIONS.HOLIDAY_IMPORTED_DATA_READ,PERMISSIONS.HOLIDAY_IMPORTED_DATA_WRITE] },
    { label: 'Staff/ Team', routerLink: '/staff', location: 'staff' ,requiredPermissions: [PERMISSIONS.STAFF_BASIC_INFORMATION_WRITE, PERMISSIONS.STAFF_BASIC_INFORMATION_READ,PERMISSIONS.STAFF_CONFIGURATION_DETAILS_WRITE,PERMISSIONS.STAFF_CONFIGURATION_DETAILS_READ,PERMISSIONS.STAFF_EMPLOYMENT_DETAILS_WRITE,PERMISSIONS.STAFF_EMPLOYMENT_DETAILS_READ]},
    { label: 'Events', routerLink: '/events', location: 'indicators',requiredPermissions: [PERMISSIONS.EVENT_DETAILS_WRITE, PERMISSIONS.EVENT_DETAILS_READ] },
    { label: 'Activities', routerLink: '/activities', location: 'activities',requiredPermissions: [PERMISSIONS.ACTIVITY_DETAILS_WRITE, PERMISSIONS.ACTIVITY_DETAILS_READ] },
  ];
  filteredSubMenuItems: any[] = []; // Stores filtered submenu items for the selected location
  activeButtonIndex: number | null = null;
  orgLogo: any;
  canAccessToOrganisation: boolean = false;
  noOrganizationLogo:string = 'assets/image/no-org-logo.webp';
  private destroy$ = new Subject<void>();
  isLoadingSubMenu: boolean = false;
  constructor(
    private breadcrumbService: BreadcrumbService,
    public sharedDataService: SharedDataService,
    private router: Router,
    private orgService: OrganizationService,
    private locService: LocationService,
    public envService: EnvironmentService,
    private permissionService: PermissionsService,
    private _locationService: UserLocationService,
    private planningDataService: PlanningDataService,
    private _maskedQueryService: MaskedQueryService
  ) {}

  ngOnInit(): void {
    this.permissionService.userPermissions$
        .pipe(takeUntil(this.destroy$))
        .subscribe((permissions) => {
          this.canAccessToOrganisation = permissions.includes(PERMISSIONS.ORGANISATION_DETAILS_WRITE) || permissions.includes(PERMISSIONS.ORGANISATION_DETAILS_READ);
        });
    this.orgService.fetchOrganization().pipe(
      switchMap((orgData: any) => {
        if (orgData.status === 200) {
          this.sharedDataService.updateorganizationDetails(orgData.body);
          this.sharedDataService.organizationId = orgData.body.id;
          this.orgDetails = orgData.body;
          this.orgLogo = this.orgDetails?.logo_url  ? `${this.envService.imgReviewUrl}/${this.orgDetails.logo_url}`
          : 'assets/image/no-org-logo.webp';
          // this.orgLogo = `${this.envService.imgReviewUrl}/${this.orgDetails.logo_url}`;
          this.sharedDataService.showData = true;
          return this.locService.fetchOrgLocations(this.sharedDataService.organizationId);
        } else {
          this.sharedDataService.showData = false;
          return EMPTY; // Return an empty observable if the orgData status is not 200
        }
      })
    ).subscribe({
      next: (locData: any) => {
        if (locData.status === 200) {
          this.sharedDataService.updateLocationData(locData.body);
          this.locDetails = locData.body;
          this.menuStates = Array(this.locDetails.length).fill(false);
          this.showLocData = true;
          // Restore selected or default location state
          const preselectedId = this._locationService.getSelLocationId();
          const targetId = preselectedId ;
          
          if (targetId && this.locDetails) {
            const targetIndex = this.locDetails.findIndex((loc: any) => loc.id === targetId);
            if (targetIndex !== -1) {
              this.selectedLocation(this.locDetails[targetIndex], targetIndex);
            }
          }
        } else {
          this.showLocData = false;
        }
      },
      error: (err) => {
        console.error('An error occurred:', err);
        this.sharedDataService.showData = false;
      }
    });
  }

  getMenuRef(index: number): MatMenu {
    return this.menuComponents.toArray()[index];
  }

  onSelectSubMenuItem(subMenuItem: any) {
    this.sharedDataService.selRouterLink = subMenuItem.routerLink + '/' + this.selectedOption.id; //store url of the tab that the user clicked
    this.planningDataService.setSelRouterLink(subMenuItem.routerLink + '/' + this.selectedOption.id) //store url of the tab that the user clicked in local storage
    this.sharedDataService.showDropDown = !this.sharedDataService.showDropDown;    
    this.sharedDataService.activeTab = '/configuration';
    if (subMenuItem.label === 'Location Details') {
      this.sharedDataService.showLocationDetails = true;
      this.sharedDataService.manageOrganization = false;
      this.sharedDataService.detailsCardTitle ='location.title';
      // const newUrl = `locations/${this.selectedOption.id}`;
      const selLocId = this._maskedQueryService.encodeParams(this.selectedOption.id)
      const newUrl = `locations/${selLocId}`;
      this.router.navigateByUrl(newUrl); // Navigate to the option's ID
      this.selectedMenu.push(
        { label: this.selectedOption.name,type:'location', url: `/locations/${this.sharedDataService.locationId}` },
        { label: subMenuItem.label, url: subMenuItem.routerLink }
      );

      this.breadcrumbService.updateBreadcrumbs(this.selectedMenu);
    } else {
      let newUrl='';
      const selLocId = this._maskedQueryService.encodeParams(this.selectedOption.id)
      if(subMenuItem.location === "indicators"){
        // newUrl=`events/${this.selectedOption.id}`;
        newUrl=`events/${selLocId}`;
      }else{
        // newUrl = `${subMenuItem.location}/${this.selectedOption.id}`;
        newUrl = `${subMenuItem.location}/${selLocId}`;
      }
      this.sharedDataService.selectedTab = subMenuItem.location;
      this.router.navigateByUrl(newUrl); // Navigate to the option's ID
      this.selectedMenu.push(
        {
          label: this.selectedOption.name,type:'location',
          url: `/locations/${this.sharedDataService.locationId}`,
        },
        {
          label: subMenuItem.label,
          url: subMenuItem.routerLink,
        }
      );
      this.breadcrumbService.updateBreadcrumbs(this.selectedMenu);
    }
  }

  onBreadcrumbClick(breadcrumb: { label: string; url: string }) {
    this.breadcrumbService.trimBreadcrumbs(breadcrumb.label);
  }

  manageOrg() {
    // if the manage organisation is already in the url , then donot need to push it into that- to prevent multiple entry for manage organsiation
    const isAlreadyAdded = this.selectedMenu.some(
      (breadcrumb: { label: string; url: string; }) => breadcrumb.label === 'Manage Organization' && breadcrumb.url === '/organization'
    );
  
    if (!isAlreadyAdded) {
    this.selectedMenu.push({ label: 'Manage Organization', url: '/organization' });
    }
    this.planningDataService.setSelRouterLink('/organization') //store url of the tab that the user clicked in local storage
    this.breadcrumbService.updateBreadcrumbs(this.selectedMenu);
    this.sharedDataService.activeTab = '/configuration';
    this.sharedDataService.manageOrganization = true;
    this.sharedDataService.detailsCardTitle ='location.title3';
    this.sharedDataService.showLocationDetails = false;
    this.sharedDataService.showDropDown = !this.sharedDataService.showDropDown;
    if(this.sharedDataService.manageOrganization){
      this.sharedDataService.showDropDown = false
    }
  }

  selectedLocation(data: any, index: number) {
    this.sharedDataService.locationId = data.id;
    this._locationService.setSelLocationId(data.id);
    this.sharedDataService.locationName = data.name;
    this._locationService.setSelLocationName(data.name)
    this.sharedDataService.updateSelectedLocId(data.id);
    this.activeButtonIndex = index;
    this.selectedOption = data;
    this.toggleMenuState(index);
    // it filters which of the menu items should be shown based on the features under user's each location
    if (data?.id) {
    this.isLoadingSubMenu = true;
      this.permissionService
        .getCurrentLocPermissions(data.id)
        .subscribe({
          // Filter submenu items based on the retrieved permissions
          next: (locationPermissions: string[]) => {
          this.filteredSubMenuItems = this.subMenuItems.filter((item) => {
            if (!item.requiredPermissions) return true; // No permission check needed
            return item.requiredPermissions.some((permission) =>
              locationPermissions.includes(permission)
            );
          });
         setTimeout(() => {
           this.isLoadingSubMenu = false;
         }, 500);
      },
      error: () => {
        this.isLoadingSubMenu = false;
      }
        });
    } else {
      this.filteredSubMenuItems = []; // if the location is not the current one, reset the filtered items
      this.isLoadingSubMenu = false;
    }
  }

  toggleMenuState(index: number): void {
    // Close all menus except the one that is clicked
    this.menuStates = this.menuStates?.map((state, i) =>
      i === index ? !state : false
    );

    // Update showDropDown to reflect the state of the clicked submenu
    this.showDropDown = this.menuStates[index];
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
